import React from 'react';
import Sidebar from './Sidebar';
import { useBlur } from '../contexts/BlurContext';

const Layout = ({ 
  children, 
  isSidebarOpen, 
  setIsSidebarOpen, 
  spreadsheets, 
  activeSpreadsheet, 
  setActiveSpreadsheet,
  onLogout
}) => {
  const { isBlurred } = useBlur();
  
  const handleLogoutClick = async (e) => {
    e.preventDefault();
    if (onLogout) {
      await onLogout();
    }
  };

  return (
    <div className="flex h-screen overflow-hidden relative">
      <div className={`${isBlurred ? 'filter blur-sm' : ''} transition-all duration-300 flex h-full w-full`}>
        <Sidebar
          isOpen={isSidebarOpen}
          setIsOpen={setIsSidebarOpen}
          spreadsheets={spreadsheets}
          activeSpreadsheet={activeSpreadsheet}
          setActiveSpreadsheet={setActiveSpreadsheet}
          onLogout={handleLogoutClick}
          className={`
            fixed top-0 left-0 z-50 h-full transition-transform duration-300 ease-in-out transform
            ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            md:relative md:translate-x-0
          `}
        />
        <div className="flex flex-col flex-1 overflow-hidden">
          <main 
            className={`
              flex-1 overflow-auto transition-all duration-300 ease-in-out
              ${isSidebarOpen ? 'md:ml-80' : 'md:ml-0'}
            `}
          >
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;

